import React from 'react';

import ReactDOM from 'react-dom/client';
//import { createRoot } from "react-dom/client";
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'App.css';
import './fonts/Inter-Regular.ttf';
import { HashRouter } from 'react-router-dom';


const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);


root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
 //document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
